import React from 'react';

/**
 * Paste in your SVG logo and return it from this component.
 * Make sure you have a height set for your logo.
 * It is recommended to keep the height within 25-35px.
 * Logo comes with a property value called `fill`. `fill` is useful
 * when you want to change your logo depending on the theme you are on.
 */
export default function Logo({ fill = '#000000', height = '100', width = '100' }) {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
         width={width} height={height} viewBox="0 0 6907.000000 6907.000000"
         preserveAspectRatio="xMidYMid meet">
      <metadata>
        Created by potrace 1.16, written by Peter Selinger 2001-2019
      </metadata>
      <g transform="translate(0.000000,6907.000000) scale(0.100000,-0.100000)"
         fill={fill} stroke="none">
        <path d="M4140 35685 l0 -10805 4888 3 c3602 3 4924 7 5027 15 766 64 1210
132 1760 272 1047 265 1930 708 2705 1353 182 152 562 531 704 702 807 972
1237 2070 1351 3455 34 413 30 977 -11 1383 -125 1268 -601 2333 -1399 3132
-640 641 -1476 1082 -2465 1299 -91 20 -176 39 -189 42 -20 4 7 19 130 73
1132 496 1949 1244 2424 2216 266 545 417 1111 486 1820 17 178 23 790 10
1007 -26 437 -82 807 -176 1174 -259 1010 -779 1804 -1571 2402 -122 91 -383
261 -524 340 -479 267 -998 466 -1615 617 -618 152 -1201 232 -2090 287 -139
8 -1424 12 -4817 15 l-4628 4 0 -10806z m8995 8317 c417 -39 610 -63 870 -113
675 -128 1244 -368 1650 -696 126 -101 318 -299 412 -423 304 -403 482 -892
550 -1510 21 -200 24 -705 5 -905 -52 -531 -179 -979 -384 -1348 -331 -598
-881 -1025 -1653 -1282 -452 -151 -880 -231 -1600 -297 -96 -8 -890 -12 -3022
-15 l-2893 -4 0 3306 0 3306 2968 -4 c2183 -3 3001 -7 3097 -15z m65 -9012
c1382 -58 2384 -313 3093 -788 666 -447 1083 -1127 1232 -2007 51 -298 59
-422 59 -840 0 -420 -8 -541 -60 -855 -169 -1017 -673 -1797 -1494 -2315 -138
-87 -441 -238 -610 -305 -551 -217 -1182 -341 -1930 -380 -123 -6 -1340 -10
-3307 -10 l-3113 0 0 3748 c0 2062 3 3752 7 3755 11 11 5850 8 6123 -3z"/>
        <path d="M28395 41143 c-370 -8 -962 -48 -1240 -84 -1539 -200 -2885 -974
-3810 -2190 -375 -492 -662 -1039 -865 -1649 -77 -230 -190 -654 -177 -666 23
-23 668 -47 2012 -74 270 -6 572 -10 672 -10 l182 0 11 43 c34 131 89 299 137
422 292 750 763 1211 1565 1529 449 178 900 293 1350 343 190 21 646 24 828 5
542 -56 1066 -195 1627 -433 382 -162 623 -308 833 -505 397 -374 585 -890
567 -1559 -6 -214 -21 -333 -62 -497 -132 -519 -457 -910 -950 -1144 -164 -78
-306 -126 -550 -188 -723 -182 -1393 -306 -2830 -521 -352 -53 -800 -123 -995
-156 -1119 -187 -1948 -402 -2686 -697 -1163 -464 -1972 -1142 -2421 -2027
-279 -551 -403 -1100 -403 -1779 0 -490 69 -986 206 -1479 322 -1165 1035
-2031 2169 -2634 219 -117 465 -228 717 -324 1185 -453 2434 -554 3764 -303
235 44 379 81 594 153 826 279 1677 843 2489 1652 296 295 521 546 812 908 91
113 173 207 183 209 32 7 62 -7 74 -33 25 -54 60 -923 82 -2004 5 -266 11
-485 12 -486 2 -2 702 -6 1557 -10 l1554 -7 -7 33 c-135 674 -248 1396 -296
1909 -26 272 -28 385 -40 3200 -19 4201 -52 6035 -121 6685 -33 312 -182 831
-351 1220 -579 1337 -1732 2294 -3375 2798 -557 171 -1150 279 -1792 327 -178
13 -682 30 -811 28 -52 -1 -149 -3 -215 -5z m3798 -7143 c17 -20 28 -49 34
-87 12 -83 8 -879 -6 -1193 -59 -1368 -173 -2127 -422 -2822 -275 -766 -659
-1376 -1200 -1903 -350 -342 -682 -577 -1134 -806 -519 -262 -1039 -424 -1605
-499 -198 -27 -624 -38 -825 -21 -638 53 -1239 240 -1857 580 -506 278 -895
667 -1125 1125 -155 309 -221 563 -230 883 -8 264 19 451 98 680 105 304 261
551 514 812 246 253 502 427 805 545 288 112 1195 340 2470 622 941 208 1080
239 1325 301 790 199 1322 399 1875 707 474 264 722 480 1032 896 72 96 140
183 150 193 31 27 72 22 101 -13z"/>
        <path d="M57410 41094 c-297 -19 -400 -28 -555 -45 -1912 -212 -3432 -1088
-4510 -2599 -897 -1259 -1408 -2867 -1540 -4845 -163 -2449 236 -4523 1168
-6080 913 -1526 2259 -2535 3922 -2940 902 -219 1949 -277 2970 -164 1490 165
2739 693 3765 1593 913 801 1552 1847 1894 3098 66 241 131 538 174 786 l9 52
-1308 0 c-1263 0 -1309 -1 -1309 -18 0 -10 -22 -106 -49 -213 -192 -763 -519
-1366 -1001 -1849 -754 -754 -1808 -1127 -3095 -1097 -1040 25 -1881 287
-2570 802 -731 546 -1260 1349 -1549 2352 -150 521 -250 1159 -271 1733 -3 85
-8 188 -11 228 l-5 72 5670 0 5671 0 5 23 c42 191 56 1265 25 1872 -48 908
-170 1691 -380 2427 -533 1877 -1641 3289 -3195 4073 -803 405 -1677 633
-2755 721 -182 14 -1023 28 -1170 18z m945 -2354 c912 -67 1666 -330 2256
-789 699 -545 1167 -1328 1389 -2326 89 -398 150 -937 150 -1322 l0 -143
-4310 0 c-4098 0 -4310 1 -4310 18 0 9 11 114 24 232 145 1278 515 2259 1129
2990 128 153 365 386 512 503 604 484 1365 765 2260 836 157 12 735 13 900 1z"/>
        <path d="M42515 41059 c-1624 -86 -2863 -501 -3834 -1282 -157 -126 -509 -477
-620 -618 -513 -654 -778 -1341 -852 -2214 -15 -176 -15 -663 0 -855 70 -900
317 -1595 767 -2160 100 -125 331 -353 474 -466 421 -334 968 -624 1664 -884
439 -163 824 -278 1516 -455 477 -122 2903 -748 3260 -841 261 -68 696 -211
880 -289 400 -169 672 -347 842 -552 212 -254 328 -551 368 -947 18 -174 8
-506 -20 -666 -106 -600 -426 -1070 -980 -1439 -471 -313 -1071 -514 -1790
-600 -299 -36 -477 -45 -865 -45 -385 0 -542 8 -845 44 -1690 204 -2729 1078
-3064 2580 -29 133 -71 384 -81 485 -3 39 -9 82 -11 98 l-6 27 -1268 0 -1268
0 4 -117 c31 -786 129 -1375 329 -1978 244 -736 613 -1344 1130 -1860 482
-483 1069 -860 1745 -1122 1034 -401 2270 -563 3755 -492 1640 78 2983 484
3984 1203 251 180 417 324 641 552 322 329 557 659 760 1066 283 568 439 1171
490 1888 13 187 13 685 0 865 -68 936 -338 1666 -830 2246 -620 730 -1836
1320 -3665 1778 -110 27 -823 197 -1585 376 -1565 369 -1634 385 -1890 460
-491 143 -891 312 -1155 486 -132 87 -326 275 -402 389 -196 294 -273 616
-252 1052 36 738 410 1297 1097 1642 420 211 997 344 1672 386 211 13 732 13
920 0 648 -45 1158 -168 1620 -391 894 -432 1393 -1150 1486 -2136 l7 -73
1283 0 1284 0 0 98 c0 133 -17 409 -36 572 -92 829 -387 1549 -890 2180 -127
159 -451 487 -614 622 -1032 852 -2333 1300 -4030 1388 -223 11 -902 11 -1125
-1z"/>
      </g>
    </svg>

  );
};
